export default __webpack_public_path__ + "static/media/teamHealthScore.a124e8da.png";